import { DateTime } from 'luxon'

export type UkTaxYearDisplay = {
  /** e.g. 2025–26 */
  label: string
  /** e.g. 6 Apr 2025 – 5 Apr 2026 */
  range: string
  startYear: number
  endYear: number
  /** Matches API financial year period, e.g. 2025-2026 */
  periodKey: string
}

/**
 * Returns the UK tax year (6 April – 5 April) that contains today's date.
 */
export function getCurrentUkTaxYear(reference = DateTime.now().setZone('Europe/London')): UkTaxYearDisplay {
  const taxYearStart = DateTime.fromObject(
    { year: reference.year, month: 4, day: 6 },
    { zone: 'Europe/London' }
  )

  const startYear = reference >= taxYearStart ? reference.year : reference.year - 1
  const endYear = startYear + 1

  return {
    label: `${startYear}–${String(endYear).slice(-2)}`,
    range: `6 Apr ${startYear} – 5 Apr ${endYear}`,
    startYear,
    endYear,
    periodKey: `${startYear}-${endYear}`,
  }
}

/** Human-readable range for an API period key (e.g. 2024-2025). */
export function periodKeyToDateRange(periodKey: string): string {
  const parts = periodKey.split('-').map((p) => parseInt(p, 10))
  if (parts.length < 2 || parts.some((n) => Number.isNaN(n))) return periodKey
  const [start, end] = parts
  return `6 Apr ${start} – 5 Apr ${end}`
}
